<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card min-height">
          <TableLoading v-if="order.publicId === '0'"/>
          <div v-else class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">Invoice # {{order.invoiceId}}</h4>
              <div class="mb-4">
                <img
                    src="@/assets/images/KikkomanNameLogo.png"
                    alt="logo"
                    height="20"
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>From:</strong>
                  <br />Kikkoman East Africa <br/>P.O BOX 52781-00100 <br/>Tel: 0790 366 564 or Tel: 0740 949 997 (CS)<br/>Tel: 0110 111 999 (Office)
                  <br />Pin P051667186Z
                </address>
                <address class="mt-5">
                  <strong>Details:</strong>
                  <br />Invoice No #: {{order.invoiceId}}
                  <br />LPO No #: {{order.lpo}}
                  <br />Delivery Date: {{order.deliveryDate}}
                  <br />Delivery Time: {{ order.timezone.timezoneName }}
                  <br />Ordered By: {{order.orderedBy}}
                  <br />Payment Due: {{ order.paymentDueDate }}
                  <br />Order Status: <order-status-component :order_status="order.status.orderStatusName"/>
                </address>
                <b-button v-if="checkForPermission(add_order_date_changes_permission)" v-b-modal.order-invoice variant="primary">Change Delivery Date</b-button>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  <strong>Invoice To:</strong>
                  <br /><strong>{{order.customer.institutionId.name}}</strong>
                  <br />P.O BOX {{ order.customer.institutionId.postalCode }}
                  <br />Tel {{ order.customer.institutionId.phoneNumber }}
                  <br />KRA PIN: {{ order.customer.institutionId.pin }}
                  <br />CUSTOMER CODE: {{ order.customer.institutionId.institutionCode }}
                </address>

                <address>
                  <strong>Shipped To:</strong>
                  <br />{{ order.customer.name }}
                  <br />Physical Address: {{ order.customer.street }}
                </address>
              </div>
            </div>
            <div class="p-2 mt-3">
              <h3 class="font-size-16">Order summary</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead class="table-light">
                <tr>
                  <th style="width: 70px">No.</th>
                  <th>Product Name</th>
                  <th>Unit Price</th>
                  <th>Order Unit</th>
                  <th>Order Unit Pieces</th>
                  <th>Discount</th>
                  <th>VAT Total</th>
                  <th>Total</th>
                  <th colspan="2" v-if="checkForPermission(change_order_item_status_permission)">Status Change</th>
                </tr>
                </thead>
                <tbody v-for="(item, index) in order.orderItems" :key="item.publicId">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{item.item.productName}}<br/>
                    <span class="font-italic" style="font-size: 9px">(Warehouse: <span v-if="item.warehouse">{{item.warehouse.name}}</span>)</span><br/>
                    <span class="font-italic" style="font-size: 9px">(Shipment: <span v-for="shipment in item.shipments" :key="shipment.publicId" class="mr-2">{{shipment.orderId}}</span>)</span>
                  </td>
                  <td>Ksh {{item.itemPrice | formatNumber}}</td>
                  <td>{{item.itemCount}}</td>
                  <td>{{ item.item.qpoUnit }}</td>
                  <td>
                    <span v-if="item.isDiscountApplied">Ksh {{item.itemDiscount | formatNumber}}</span>
                    <span v-else>No Discount</span>
                  </td>
                  <td>Ksh {{item.itemVat | formatNumber}}</td>
                  <td>Ksh {{item.grossItemTotal | formatNumber}}</td>
                  <template v-if="item.availableStatusChanges.length == 0">
                    <td>
                      <order-status-component :order_status="item.status.orderStatusName"/>
                    </td>
                  </template>
                  <template v-else>
                    <td v-if="checkForPermission(change_order_item_status_permission)">
                      <multiselect v-model="item.status" :options="item.availableStatusChanges" open-direction="bottom"
                                   placeholder="Select one" label="orderStatusName" track-by="orderStatusName" :searchable="true">
                        <span slot="noResult">No status found. Change search query.</span>
                      </multiselect>
                    </td>
                    <td v-if="checkForPermission(change_order_item_status_permission)">
                      <b-button variant="dark" size="sm" class="py-1 text-white my-2" @click="updateOrderItem(item)" :disabled="ordersLoading">
                        Update Status
                      </b-button>
                    </td>
                  </template>
                </tr>
                </tbody>
              </table>
              <div class="row justify-content-between w-100 my-5">
                <div class="col-4"></div>
                <div class="col-4">
                  <div class="my-2 pb-2">
                    <strong>VAT:</strong>
                    <p class="float-end">Ksh {{order.orderVat | formatNumber}}</p>
                  </div>
                  <div class="my-2 pb-2">
                    <strong>Total Discount:</strong>
                    <p class="float-end">Ksh {{order.orderDiscount | formatNumber}}</p>
                  </div>
                  <div class="my-2 pb-2">
                    <strong>Total:</strong>
                    <p class="float-end">Ksh {{order.grossOrderTotal | formatNumber}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-print-none">
              <div>

                <div class="mb-3">
                  <b-button v-if="order.status.orderStatusName === 'Delivered' && checkForPermission(credit_note_permissions)" v-b-modal.credit-note variant="primary">Generate Credit Note</b-button>
                </div>
                <div v-if="checkForPermission(change_order_status_permission)" class="row float-start">
                  <multiselect v-model="status" :options="order.availableStatusChanges" open-direction="top"
                               placeholder="Select one" label="orderStatusName" track-by="orderStatusName" :searchable="true">
                    <span slot="noResult">No status found. Change search query.</span>
                  </multiselect>
                  <b-button variant="danger" class="text-white mx-2 mt-2"  @click="chngeOrderStatus(order.publicId)" :disabled="ordersLoading">
                    Change Order Status
                  </b-button>
                  <div class="col-12">

                  </div>

                </div>
              </div>
              <div class="float-end button-items">
                <div v-if="checkForPermission(generate_order_delivery_note_permission) && order.status.orderStatusName !== 'Cancelled'">
                  <button v-if="invoiceLoading" class="btn btn-info waves-effect waves-light me-1" :disabled="invoiceLoading">Loading</button>
                  <button v-else class="btn btn-info waves-effect waves-light me-1" @click="downloadInvoice(order.publicId, order.invoiceId)"><i class="fa fa-print mr-2"></i><span class="ml-3">&ensp; Download Invoice</span> </button>
                </div>

                <div v-if="checkForPermission(generate_order_invoice_permission) && order.status.orderStatusName !== 'Cancelled'">
                  <button v-if="noteLoading" class="btn btn-dark waves-effect waves-light me-1" :disabled="noteLoading">Loading</button>
                  <button v-else class="btn btn-dark me-1" @click="downloadDeliveryNote(order.publicId, order.invoiceId)"><i class="fa fa-print mr-2"></i><span class="ml-3">&ensp; Download Delivery Note</span> </button>
                </div>

              </div>
            </div>
          </div>
          <b-modal
              id="order-invoice"
              centered
              hide-footer
              hide-header
              title-class="font-18">
            <div class="p-2">
              <h3>Change Delivery Date</h3>
              <change-delivery-date-modal-component @changeDate="changDeliveryDate" :current_date="order.deliveryDate" :today="today"/>
              <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('order-invoice')">Close</b-button>
            </div>
          </b-modal>
          <b-modal
              id="credit-note"
              centered
              hide-footer
              hide-header
              size="lg"
              title-class="font-18">
            <div class="p-2">
              <h3 class="mb-4">Generate Credit Note</h3>
              <credit-note-generation-component :is-disabled="true"
                                                :selected-order="{'publicId': order.publicId, 'customer': order.customer, 'invoiceId': order.invoiceId, 'orderItems': order.orderItems}"
                                                @creditAction="createCreditNote"/>
              <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('credit-note')">Close</b-button>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import ChangeDeliveryDateModalComponent from "@/components/orders/change-delivery-date-modal-component";
import OrderStatusComponent from "@/components/orders/order-status-component";
import {SINGLE_CUSTOMER_ORDER} from "@/gql/orders";
import {mapActions, mapGetters} from "vuex";
import {errorToast, successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import {permissions} from "@/router/permissions";
import Multiselect from "vue-multiselect";
import CreditNoteGenerationComponent from "@/components/finance/credit-note-generation-component";
import moment from "moment";

export default {
  page: {
    title: "Order Invoice",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    CreditNoteGenerationComponent,
    TableLoading, OrderStatusComponent, ChangeDeliveryDateModalComponent, PageHeader, Layout, Multiselect},
name: "order-invoice",
  data() {
    return {
      title: "Order Invoice",
      items: [
        {
          text: "Orders",
          href: routeItems.customer_orders_route
        },
        {
          text: "Order Invoice",
          active: true
        }
      ],
      generate_order_delivery_note_permission: permissions.generate_order_delivery_note_permission,
      generate_order_invoice_permission: permissions.generate_order_invoice_permission,
      change_order_item_status_permission: permissions.change_order_item_status_permission,
      add_order_date_changes_permission: permissions.add_order_date_changes_permission,
      change_order_status_permission: permissions.change_order_status_permission,
      credit_note_permissions: permissions.credit_note_permissions,
      order: {
        publicId: '0',
        invoiceId: "",
        lpo: "",
        deliveryDate: "",
        timezone: {
          timezoneName:""
        },
        orderedBy:"",
        paymentDueDate:"",
        status: {
          orderStatusName:"",
          isOrderCompleteStatus: true,
          isOrderCancelledStatus: true,
        },
        customer: {
          name: "",
          customerCode: "",
          addressLine1: "",
          street: "",
          institutionId: {
            name: "",
            pin: "",
            postalCode: "",
            institutionCode: "",
            phoneNumber: "",
          }
        },
        orderItems: [{
          item: {
            productName: "",
            qpoUnit:""
          },
          itemPrice: "",
          isDiscountApplied: "",
          itemDiscount: "",
          netItemTotal: "",
          itemVat: "",
          grossItemTotal: "",
          availableStatusChanges: [{
            publicId: "",
            orderStatusName: ""
          }],
          status: {
            publicId: "",
            orderStatusName: ""
          }
        }],
        netOrderTotal: "",
        orderVat: "",
        orderDiscount: "",
        grossOrderTotal: "",
        canCancelOrder: false
      },
      invoiceLoading: false,
      noteLoading: false,
      status: '',
    }
  },
  apollo: {
    order: {
      query: SINGLE_CUSTOMER_ORDER,
      variables(){
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading'
    }),
    today(){
      return moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    ... mapActions({
      changeOrderStatus: 'orders/changeOrderStatus',
      changeOrderDeliveryDate: 'orders/changeOrderDeliveryDate',
      updateOrder: 'orders/updateOrderItem',
      generateOrderInvoice: 'http/generateOrderInvoice',
      generateDeliveryNote: 'http/generateDeliveryNote',
      addNewCreditOrder: 'orders/addNewCreditOrder'
    }),
    async chngeOrderStatus(orderId){
      if (this.status !== ''){
        const data = {orderId: orderId ,statusId: this.status.publicId}
        await this.changeOrderStatus(data).then(resp => {
          if(resp.message){
            successToast(`${resp.message}`)
            this.$apollo.queries.order.refetch()
          }
        })
      }
    },
    async changDeliveryDate(date){
      const data = {
        id: this.order.publicId,
        newDate: date,
        isOrder: true
      }
      await this.changeOrderDeliveryDate(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.order.refetch()
        }
      })
    },
    async updateOrderItem(item){
      const shipment_ids = []
      item.shipments.forEach((id) => {
        shipment_ids.push(id.publicId)
      })
      const data = {
        id: item.publicId,
        order: this.order.publicId,
        itemId: item.item.publicId,
        itemCount: parseInt(item.itemCount),
        warehouseId: item.warehouse.publicId,
        shipments: shipment_ids,
        status: item.status.publicId
      }
      await this.updateOrder(data).then(resp => {
        if(resp.publicId){
          successToast(`Item updated successfully`)
          this.$apollo.queries.order.refetch()
        }
      })
    },
    async downloadInvoice(orderId, orderInvoice){
      this.invoiceLoading = true;

      const response = await this.generateOrderInvoice(orderId)
      if(response.data.type === "application/pdf"){
        downloadFileConfig(response, `${orderInvoice} Order Invoice.pdf`)
        await this.$apollo.queries.order.refetch()
      }else {
        errorToast('Error generating order invoice')
      }
      this.invoiceLoading = false;
    },
    async downloadDeliveryNote(orderId, orderInvoice){
      this.noteLoading = true;

      const response = await this.generateDeliveryNote(orderId)
      if(response.data.type === "application/pdf"){
        downloadFileConfig(response, `${orderInvoice} Order Delivery Note.pdf`)
        await this.$apollo.queries.order.refetch()
      }else {
        errorToast('Error generating delivery note')
      }

      this.noteLoading = false;
    },
    async createCreditNote(data){
      await this.addNewCreditOrder(data).then(resp => {
        if(resp.publicId){
          successToast(`Credit Note created successfully`)
        }

      })
    }
  }
}
</script>

<style scoped>

</style>
